module.exports = __webpack_public_path__ + "static/media/by-category.d466eb3c.png";